import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" {...props}><path fill="none" stroke="#2E5FCA" strokeWidth="1.75" d="M1.015 18.974c-.174.253 1.157-1.345 3.994-4.793zM9.403 1a7.19 7.19 0 100 14.38 7.19 7.19 0 000-14.38z" /></svg>);